import { action, observable } from 'mobx';

import { currencyName, networkId } from '@/constants/wallet';
import { WalletProviderState } from '@/types/wallet';

export default class WalletStore {
  @observable public accessor state: Partial<WalletProviderState> = {};
  @observable public accessor currencyName: string = currencyName;
  @observable public accessor networkId: number = networkId;

  @action.bound setState(state: Partial<WalletProviderState>) {
    this.state = { ...this.state, ...state };
  }
}
